import React, { useEffect, useState } from "react";
import DatePicker1 from "react-datepicker";

import "./datepicker.css";

const DatePicker = ({ dateValue = "", scheduleInfo, setStartDate }) => {
  const [newDate, setNewDate] = useState("");

  useEffect(() => {
    if (scheduleInfo.repeat === "Never") {
      const date = new Date();
      formatDate(date);
      // const startDate = formatEndDate(date);
      // setStartDate({ ...scheduleInfo, startDate});
      // setNewDate(date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleInfo.repeat]);

  const formatEndDate = (date) => {
    const day =
      date.getDate() < 10
        ? "0" + String(date.getDate())
        : String(date.getDate());
    const month =
      date.getMonth() + 1 < 10
        ? "0" + String(date.getMonth() + 1)
        : String(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const formatDate = (date) => {
    const startDate = formatEndDate(date);
    setStartDate({ ...scheduleInfo, startDate });
    setNewDate(date);
  };

  return (
    <div className="new-custom-date">
      <DatePicker1
        className="shadow-none"
        dateFormat="dd-MM-yyyy"
        selected={newDate}
        customInput={<CustomInput />}
        placeholderText="dd-mm-yyyy"
        minDate={new Date()}
        onChange={(date) => formatDate(date)}
      />
    </div>
  );
};

function CustomInput(props) {
  return (
    <div className="input-group custom-input-border-style">
      <input
        {...props}
        className="border-0 shadow-none"
        placeholder="dd-mm-yyyy"
      />
      <span className="input-group-append">
        <span className="bg-transparent border-0 input-group-text">
          <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 2.875H3C1.89543 2.875 1 3.77043 1 4.875V18.875C1 19.9796 1.89543 20.875 3 20.875H17C18.1046 20.875 19 19.9796 19 18.875V4.875C19 3.77043 18.1046 2.875 17 2.875Z"
              stroke="#5C5F62"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 0.875V4.875"
              stroke="#5C5F62"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 0.875V4.875"
              stroke="#5C5F62"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 8.875H19"
              stroke="#5C5F62"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </span>
    </div>
  );
}

export default DatePicker;
